import {
    DeviceType,
    EXTENSION_OR_ENDPOINT_MAX,
    DeviceTypeApiString,
    GROUP_MAX
} from '../../../NonReact/constants/DeviceTypes'

/** Tab identifiers for the device modal. */
export enum DeviceConfigurationTabID {
    GENERAL = 0,
    ADVANCED = 1,
    DEVICE_MEMBERS = 2,
    AGENT_MEMBERS = 3,
    DNIS_MEMBERS = 4,
    LINKED_ENTITIES = 5
}

/** Default backend {@code DeviceType} string used for new devices and fallbacks (extension/endpoint). */
export const DEFAULT_DEVICE_TYPE: string = DeviceTypeApiString.ExtensionOrEndpoint

/** Device type ID range for group devices (39 = super, 40–55 = core hunt groups, 56–57 = department and security group). */
export const GROUP_DEVICE_TYPE_MIN: number = DeviceType.GroupSuper
export const GROUP_DEVICE_TYPE_MAX: number = Number.parseInt(GROUP_MAX, 10)

/** Numeric group collective device type. */
export const GROUP_COLLECTIVE_TYPE: number = DeviceType.GroupCollective

/** Extension device type range. */
export const EXTENSION_TYPE_MIN: number = DeviceType.ExtensionOrEndpoint
export const EXTENSION_TYPE_MAX: number = Number.parseInt(EXTENSION_OR_ENDPOINT_MAX, 10)

/** ACD group device type. */
export const ACD_GROUP_TYPE: number = DeviceType.GroupAcd

/**
 * Whether the given numeric device type ID represents a group device.
 *
 * @param deviceTypeID - Numeric device type from the form or DTO.
 * @returns True when the type falls in the group range (39–57 inclusive), matching {@code CTelephonyModelConst.IsDeviceTypeGroup}.
 */
export const isGroupDeviceType = (deviceTypeID: number): boolean =>
    deviceTypeID >= GROUP_DEVICE_TYPE_MIN && deviceTypeID <= GROUP_DEVICE_TYPE_MAX

/**
 * Whether the given numeric device type ID represents an extension.
 *
 * @param deviceTypeID - Numeric device type from the form or DTO.
 * @returns True when the type falls in the extension range (20–29 inclusive).
 */
export const isExtensionDeviceType = (deviceTypeID: number): boolean =>
    deviceTypeID >= EXTENSION_TYPE_MIN && deviceTypeID <= EXTENSION_TYPE_MAX

/**
 * Whether the given numeric device type ID is an ACD group.
 *
 * @param deviceTypeID - Numeric device type from the form or DTO.
 * @returns True when the type is 43 (ACD group).
 */
export const isAcdGroupDeviceType = (deviceTypeID: number): boolean => deviceTypeID === ACD_GROUP_TYPE
